import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NotificationComponent } from '@core/components/notification/notification.component';
import { SnackBarConfig } from '@shared/models/core.interface';
import { AppService } from './app.service';

@Injectable()
export class SnackbarService {
  private defaultTimeoutInMS: number = 10000; 
  private defaultHorizontalPosition: MatSnackBarHorizontalPosition = 'end';
  private defaultVerticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private _appService: AppService, private _snackBar: MatSnackBar) {
    const verticalPositionConfig = this._appService.getAppSettings()?.snackBar.verticalPosition;
    const horizontalPositionConfig = this._appService.getAppSettings()?.snackBar.horizontalPosition;
    const timeoutConfig = this._appService.getAppSettings()?.snackBar.timeout;
    this.initializeSnackBarConfigs(timeoutConfig, horizontalPositionConfig, verticalPositionConfig);
  }

  private initializeSnackBarConfigs(timeout: number, horizontalPosition: string, verticalPosition: string) {
    // Resolving position.
    const horizontalPositionValid = (horizontalPosition === 'start' || 'center' || 'end' || 'left' || 'right');
    const verticalPositionValid = (verticalPosition === 'top' || 'bottom');

    if (horizontalPositionValid) this.defaultHorizontalPosition = horizontalPosition as MatSnackBarHorizontalPosition;
    if (verticalPositionValid) this.defaultVerticalPosition = verticalPosition as MatSnackBarVerticalPosition;

    // Resolving timeout.
    this.defaultTimeoutInMS = (timeout) ?? this.defaultTimeoutInMS;
  }

  showSnackBar(data: SnackBarConfig) {
    let snackBarRef = this._snackBar.openFromComponent(NotificationComponent, {
      duration: this.defaultTimeoutInMS,
      horizontalPosition: this.defaultHorizontalPosition,
      verticalPosition: this.defaultVerticalPosition,
      data: data
    });

    snackBarRef.afterDismissed().subscribe(action => {
      // console.debug("Action: ", action);
    })
  }

  showWarningSnackBar(title: string, message: string, action: string) {
    let snackBarRef = this._snackBar.openFromComponent(NotificationComponent, {
      duration: 5000,
      horizontalPosition: this.defaultHorizontalPosition,
      verticalPosition: this.defaultVerticalPosition,
      data: {
        title: title,
        message: message,
        info: false,
        warn: true,
        err: false,
        Success: false
      }
    });
    snackBarRef.afterDismissed().subscribe(() => {
    });
  }

  showErrorSnackBar(title: string, message: string, action: string) {
    let snackBarRef = this._snackBar.openFromComponent(NotificationComponent, {
      duration: 5000,
      horizontalPosition: this.defaultHorizontalPosition,
      verticalPosition: this.defaultVerticalPosition,
      data: {
        title: title,
        message: message,
        info: false,
        warn: false,
        err: true,
        Success: false
      }
    });
    snackBarRef.afterDismissed().subscribe(() => {
    });
  }

  showSuccessSnackBar(title: string, message: string, action: string) {
    let snackBarRef = this._snackBar.openFromComponent(NotificationComponent, {
      duration: 5000,
      horizontalPosition: this.defaultHorizontalPosition,
      verticalPosition: this.defaultVerticalPosition,
      data: {
        title: title,
        message: message,
        info: false,
        warn: false,
        err: false,
        Success: true
      }
    });
    snackBarRef.afterDismissed().subscribe(() => {
    });
  }
}
